import type { SelectOption } from '../../lib/types';

export function setupSearchFilter(
    searchBox: HTMLInputElement,
    selectEl: HTMLSelectElement,
    getOptions: () => SelectOption[]
): void {
    searchBox.addEventListener('input', function () {
        const term = (this as HTMLInputElement).value.toLowerCase();
        const selected = new Set(Array.from(selectEl.selectedOptions).map(o => o.value));

        selectEl.innerHTML = '';
        for (const item of getOptions()) {
            if (item.text.toLowerCase().includes(term) || selected.has(item.value)) {
                const opt = document.createElement('option');
                opt.value = item.value;
                opt.textContent = item.text;
                opt.selected = selected.has(item.value);
                selectEl.appendChild(opt);
            }
        }
    });
}
